import { CheckTotal } from "../payment/CheckTotal"
import { Tip } from "../payment/Tip"
import { Receipt } from "../postcheckout/Receipt"
import { CheckFlat } from "./CheckFlat"
import { CheckItemFlat } from "./CheckItemFlat"
import { CheckSummary } from "./CheckSummary"

export const loadDemoCheckSummaryData = (): CheckSummary => {
    /*var checkSummary: CheckSummary = {
        id: "5",
        external_id: "5",
        number: "5",
        open: true,
        total: 2522,
        total_string: "$25.22",
        amount_due: 2522,
        amount_due_string: "25.22",
        total_with_service_charge: 2617,
        total_with_service_charge_string: "$26.17",
        unclaimed_amount: 2522,
        unclaimed_amount_string: "$25.22",
        payments: null,
        check_state: 0,
        disable_split: false,
        is_split_by_seat_locked: false,
        is_all_check: false
    }*/

    var checkSummary: CheckSummary = {
        id: "5",
        external_id: "5",
        number: "5",
        open: true,
        total: 455,
        total_string: "$4.55",
        amount_due: 455,
        amount_due_string: "4.55",
        total_with_service_charge: 455,
        total_with_service_charge_string: "$4.55",
        unclaimed_amount: 455,
        unclaimed_amount_string: "$4.55",
        payments: null,
        check_state: 0,
        disable_split: false,
        is_split_by_seat_locked: false,
        is_all_check: false
    }
        
    return checkSummary
}

export const loadDemoCheckData = (): CheckFlat => {

    var checkItems: CheckItemFlat[] = []
    /*var checkItem: CheckItemFlat = {
        name: "Boneless Wings",
        price: "$4.99",
        actualPrice: 499,
        quantity: "1",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: true,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Baby Back Ribs",
        price: "$15.99",
        actualPrice: 1599,
        quantity: "1",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: true,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Sweet Tea",
        price: "$2.69",
        actualPrice: 269,
        quantity: "1",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: true,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "SubTotal",
        price: "$23.67",
        actualPrice: 2367,
        quantity: "",
        isTotal: false,
        isSubTotal: true,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Taxes & Fees",
        price: "$2.50",
        actualPrice: 250,
        quantity: "",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: true,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Total",
        price: "$26.17",
        actualPrice: 2617,
        quantity: "",
        isTotal: true,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    var checkFlat: CheckFlat = {
        remainingBalance: 2522,
        remainingBalanceString: "$25.22",
        table: "5",
        checkNumber: "5122",
        details: checkItems,
    }*/

    var checkItem = {
        name: "Meatless Grinder",
        price: "$4.25",
        actualPrice: 425,
        quantity: "1",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: true,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "SubTotal",
        price: "$4.25",
        actualPrice: 425,
        quantity: "",
        isTotal: false,
        isSubTotal: true,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Taxes & Fees",
        price: "$.30",
        actualPrice: 30,
        quantity: "",
        isTotal: false,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: true,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    checkItem = {
        name: "Total",
        price: "$4.55",
        actualPrice: 455,
        quantity: "",
        isTotal: true,
        isSubTotal: false,
        isSplitTotal: false,
        isPaidTotal: false,
        isTip: false,
        isTax: false,
        isDiscount: false,
        isServiceCharge: false,
        isItem: false,
        isItemModifier: false,
        isComboItem: false,
        isComboItemModifier: false,
        isItemDiscount: false,
        isCheckPleaseServiceCharge: false,
        hasModifiers: false,
        hasComboItems: false,
        isVoidedItem: false
    }
    checkItems.push(checkItem)

    var checkFlat: CheckFlat = {
        remainingBalance: 455,
        remainingBalanceString: "$4.55",
        table: "5",
        checkNumber: "5122",
        details: checkItems,
    }

    return checkFlat
}

export const loadDemoCheckTotal = (): CheckTotal => {

    var customTip: Tip = {
        key: 0,
        value: "0",
        amount: 0
    }

    var tips: Tip[] = []

    var tip1: Tip = {
        key: 18,
        value: "0.82",
        amount: 4
    }
    tips.push(tip1)

    var tip2: Tip = {
        key: 20,
        value: "0.91",
        amount: 5
    }
    tips.push(tip2)

    var tip3: Tip = {
        key: 22,
        value: "1.00",
        amount: 5
    }
    tips.push(tip3)

    var checkTotal: CheckTotal = {
        total: 455,
        total_string: "$4.55",
        sub_total: 425,
        sub_total_string: "$4.25",
        tax: 30,
        tax_string: "$0.30",
        check_please_service_charge: 0,
        check_please_service_charge_string: "$0.00",
        tax_with_service_charge: 30,
        tax_with_service_charge_string: "$0.30",
        amount_due: 455,
        amount_due_string: "$4.55",
        amount_due_string_no_currency: "4.55",
        tips: tips,
        default_tip: 20,
        minimum_tip: 0,
        minimum_tip_amount: 0,
        minimum_tip_amount_string: "",
        show_custom_tip_button: false,
        custom_tip_button_text: "",
        custom_tip: customTip,
        has_auto_gratuity: false
    }

    return checkTotal
}


export const loadDemoReceipt = (): Receipt => {

    var receipt: Receipt = {
        dining_date: "",
        check_number: "5515",
        check_please_payment_id: "",
        receipt_number: "55158322",
        total: 455,
        total_string: "$4.55",
        sub_total: 425,
        sub_total_string: "$4.25",
        amount_paid: 546,
        amount_paid_string: "$5.46",
        amount_paid_percentage: 0,
        amount_paid_percentage_string: "",
        tip: 91,
        tip_string: "$0.91",
        check_please_service_charge: 0,
        check_please_service_charge_string: "$0.00",
        tax: 30,
        tax_string: "$0.30",
        tax_with_service_charge: 121,
        tax_with_service_charge_string: "$1.21",
        payment_type: "",
        payment_method: "Visa",
        card_number: "XXXXXXXXXXXX1111",
        auth_code: "191250084643630143",
        check_paid_date_time: new Date().toLocaleString(),
        check: loadDemoCheckData()
    }

    return receipt
}

